var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 394.2 135.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.77,46.12l-.36,63.65c-32.98-30.31-80.48-65.94-123.43-86.12C204.87-.36,151.31-6.33,105.16,6.85c-25.37,7.25-48.68,20.85-67.41,39.34C18.1,65.59,5.05,88.99,0,113.87l14.14,2.87C23.02,73,61.19,34.42,109.12,20.73c42.79-12.22,92.77-6.55,140.72,15.99,36.33,17.07,82.24,49.21,118.74,82.68l-82.94-4.07-.71,14.41,108.76,5.34.51-88.87-14.43-.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.e39ba63f9fe33b8f7d4231296ccfbdc5.svg";
export { ForwardRef as ReactComponent };